import Immutable from 'immutable';
import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';

// components
import Calendar from './_Calendar';
import OpenBooksTooltip from './_OpenBooksTooltip';
import { Link } from 'react-router';

class Index extends React.Component {
  static propTypes = {
    appointment:          PropTypes.instanceOf(Immutable.Map),
    doctor:               PropTypes.instanceOf(Immutable.Map),
    doctorAvailabilities: PropTypes.instanceOf(Immutable.Map),
    openingInfo: PropTypes.string
  };

  _renderOpeningInfo = () => {
    const { openingInfo } = this.props;

    return openingInfo && openingInfo !== '' ? openingInfo : 'Click to fill in next book opens';
  };

  render() {
    return (
      <div className='manager__calendar-index'>
        <div className='manager__calendar-index__header'>
          <div className={ 'manager-header-opening-info' }>
            <Link className={ 'manager-header-opening-info__link' } key='settings' to={ '/managers/edit#opening-info' }>
              <i  aria-hidden='true' className='fa fa-book manager-header-opening-info__icon' />
            </Link>
            <div className={ 'manager-header-opening-info__content' }>
              <div className={ 'manager-header-opening-info__title' }>Next book opens:</div>
              <div className={ 'manager-header-opening-info__text' }>
                <Link className={ 'manager-header-opening-info__link' } key='settings' to={ '/managers/edit#opening-info' }>
                  <div>{this._renderOpeningInfo()}</div>
                </Link>
              </div>
            </div>
          </div>
          <div className='manager__calendar-index__header__left'>
            { this._renderLoadingIndicator() }
          </div>
          <div className='manager__calendar-index__header__right'>
            <OpenBooksTooltip />
          </div>
        </div>
        <Calendar />
      </div>
    );
  }
  // private

  _renderLoadingIndicator() {
    const { appointment, doctor, doctorAvailabilities } = this.props;

    const loading = appointment.get('loading') ||
          doctor.get('loading') ||
          doctorAvailabilities.get('loading') ||
          false;

    let element = null;

    if (loading) {
      document.querySelector('body').style.pointerEvents = 'none';
      element = (
        <div className='manager__calendar-index__header__loading-indicator'>Loading...</div>
      );
    } else {
      document.querySelector('body').style.pointerEvents = 'auto';
    }

    return element;
  }
}

const mapStateToProps = (state) => {
  return {
    appointment:          state.get('appointment'),
    doctor:               state.get('doctor'),
    doctorAvailabilities: state.get('doctorAvailabilities'),
    openingInfo: state.getIn(['currentUser', 'data', 'office', 'openingInfo'])
  };
};

export default connect(mapStateToProps)(Index);



// WEBPACK FOOTER //
// ./app/components/managers/calendar/Index.jsx